import React, { Component } from 'react';

class MailPreview extends Component {

    render () {
        const {isModelOpen,msgPreview,content} = this.props;
        const isModalShow = isModelOpen;
        return (
            <div className="modal" tabindex="-1" data-backdrop="static" data-keyboard="false" style={{display:isModalShow === true ? 'block' : 'none'}}>
                <div className="view" style={{"overflow":"inherit"}}>
                    <div className="table_Box dataTables_wrapper">
                        
                        <div className="table_Header bg-light_black">
                            <div className="d-flex align-items-center justify-content-between">
                                <h5 className="modal-title secondary_color pl-2 mb-0" style={{color:'#ffffff'}}> Message Preview </h5>   
                                <button type="button" className="btn btn-border border-default" onClick={msgPreview}> Close </button>
                            </div>             
                        </div>

                        <div className="table_Body preview_Body">
                            <div className="row justify-content-md-center">
                                <div className="col-12">
                                     <div className="form-group mb-0">
                                        <div dangerouslySetInnerHTML={{ __html: content }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MailPreview;